import { proxy } from 'valtio';
import { PIP_MODES, PIP_STORAGE_KEYS } from './constants';

export type PipMode = (typeof PIP_MODES)[keyof typeof PIP_MODES];

function getInitialMode(): PipMode {
  try {
    const stored = localStorage.getItem(PIP_STORAGE_KEYS.MODE);
    if (stored === PIP_MODES.ALWAYS || stored === PIP_MODES.CALLS_ONLY)
      return stored;
  } catch {
    // localStorage unavailable (private browsing, restricted iframe, etc.)
  }
  return PIP_MODES.CALLS_ONLY;
}

function getInitialEnabled(): boolean {
  try {
    const stored = localStorage.getItem(PIP_STORAGE_KEYS.ENABLED);
    if (stored === 'false') return false;
  } catch {
    // localStorage unavailable (private browsing, restricted iframe, etc.)
  }
  return true;
}

export const pipState = proxy({
  enabled: getInitialEnabled(),
  mode: getInitialMode(),
  floating: false,
});

export function setPipEnabled(enabled: boolean) {
  pipState.enabled = enabled;
  try {
    localStorage.setItem(PIP_STORAGE_KEYS.ENABLED, String(enabled));
  } catch {
    // localStorage unavailable
  }
  if (!enabled) {
    pipState.floating = false;
    window.documentPictureInPicture?.window?.close();
  }
}

export function setPipMode(mode: PipMode) {
  pipState.mode = mode;
  try {
    localStorage.setItem(PIP_STORAGE_KEYS.MODE, mode);
  } catch {
    // localStorage unavailable
  }
}

export function setFloating(floating: boolean) {
  pipState.floating = floating;
}

/** Close the PiP window programmatically. */
export function closePipWindow() {
  window.documentPictureInPicture?.window?.close();
}
